import { defineSlotRecipe } from '@chakra-ui/react';
import { tagAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: tagAnatomy.keys(),
  defaultVariants: {
    size: 'lg',
    variant: 'subtle',
    colorPalette: 'brandSecondary',
  },
  variants: {
    size: {
      lg: {},
    },
    variant: {
      subtle: {},
    },
  },
});
